import { isSessionOverlaping } from '../../../../../../data/filters/scheduleFilters';

/**
 * Returns true if there are aditionar sessions on a round that can be selected by the user
 *
 * @param {Array} selected Currently selected sessions
 * @param {Array} aditional Other sessions on the round that aren't selected
 * @returns boolean
 */
export function hasMoreSelectableSessions(selected, aditional) {
    return aditional.find(aditionalSession => !selected.find(session => isSessionOverlaping(session, aditionalSession)));
}
